import { ActionTypes } from '../constants';
import { RootActionTypes } from '../../../stores/types';

export default function hideAllTariffCodes(): RootActionTypes {
  return { type: ActionTypes.HIDE_ALL_TARIFF_CODES };
}
